export const environment = {
  production: false,
  baseServiceUrl: '/api',
  baseLoginServiceUrl: '/api',
  baseAppPath: 'app'
};
